

// import React, { useContext } from 'react'
// import { AppContext } from '../../contexts/AppContext'
// import RenderWeekHeader from './RenderWeekHeader';

// const WEEKS_PER_YEAR = 59;

// function weekInYear(weekAbs) {
//   // Convert an absolute week number (1,2,... possibly > WEEKS_PER_YEAR)
//   // into the week number inside the year [1..WEEKS_PER_YEAR].
//   // If invalid/<=0 returns 0.
//   const n = Number(weekAbs);
//   if (!Number.isFinite(n) || n <= 0) return 0;
//   return ((Math.floor(n) - 1) % WEEKS_PER_YEAR) + 1;
// }

// export default function DynamicTableHeader({ pastActualsCount, forecastCount, projectionCount, weeklyRanges, lastWeekIndexToMonthIdx, monthsMeta }) {
//   const { PastActualsOneValue, PastActualsTwoValue, PastForecastOneValue, PastForecastTwoValue } = useContext(AppContext)

//   return (
//     <>
//       <th className='columfix text-left fixed-left'>KPI</th>
//       {PastActualsOneValue && <><th>Jan</th>
//         <th>Feb</th>
//         <th>Mar</th>
//         <th>Apr</th>
//         <th>May</th>
//         <th>Jun</th>
//         <th>July</th>
//         <th>Aug</th>
//         <th>Sep</th>
//         <th>Oct</th>
//         <th>Nov</th>
//         <th>Dec</th>
//       </>}

//       {PastActualsTwoValue &&
//         Array.from({ length: pastActualsCount }, (_, i) => {
//           const weekNumber = i + 1;
//           const wrapped = weekInYear(weekNumber);
//           const th = RenderWeekHeader(wrapped, weeklyRanges);
//           return React.cloneElement(th, { key: `pastA-${i}` });
//         })}

//       {PastForecastOneValue &&
//         Array.from({ length: forecastCount }, (_, i) => {
//           const weekNumber = pastActualsCount + i + 1;
//           const wrapped = weekInYear(weekNumber);
//           const th = RenderWeekHeader(wrapped, weeklyRanges);
//           return React.cloneElement(th, { key: `pastF-${i}` });
//         })}

//       {PastForecastTwoValue &&
//         Array.from({ length: projectionCount }, (_, i) => {
//           const weekNumber = pastActualsCount + forecastCount + i + 1;
//           const wrapped = weekInYear(weekNumber);
//           const th = RenderWeekHeader(wrapped, weeklyRanges);

//           // keep data-projection-index and add a key
//           return React.cloneElement(th, { "data-projection-index": i, key: `proj-${i}` })
//         })}
//     </>
//   )
// }


// src/components/table/DynamicTableHeader.jsx
// import React, { useContext } from 'react'
// import { AppContext } from '../../contexts/AppContext'
// import RenderWeekHeader from './RenderWeekHeader';

// const WEEKS_PER_YEAR = 59;
// function weekInYear(weekAbs) {
//   const n = Number(weekAbs);
//   if (!Number.isFinite(n) || n <= 0) return 0;
//   return ((Math.floor(n) - 1) % WEEKS_PER_YEAR) + 1;
// }

// function monthLabelFromMeta(mm) {
//   if (!mm) return '';
//   // mm could be [year, month] or { year, month }
//   let y, m;
//   if (Array.isArray(mm)) {
//     y = mm[0]; m = mm[1];
//   } else if (typeof mm === 'object') {
//     y = mm.year ?? mm[0];
//     m = mm.month ?? mm[1] ?? mm.month_number;
//   } else {
//     return String(mm);
//   }
//   if (!m) return String(mm);
//   try {
//     return new Date(Number(y) || new Date().getFullYear(), Number(m) - 1)
//       .toLocaleString('en-US', { month: 'short', year: 'numeric' })
//       .replace(/\s\d{4}$/, (y && ` ${y}`) || '');
//   } catch {
//     return `${m}/${y}`;
//   }
// }

// export default function DynamicTableHeader({
//   pastActualsCount,
//   forecastCount,
//   projectionCount,
//   weeklyRanges,
//   lastWeekIndexToMonthIdx = {},
//   monthsMeta = []
// }) {
//   const { PastActualsOneValue, PastActualsTwoValue, PastForecastOneValue, PastForecastTwoValue } = useContext(AppContext);

//   // helper to render a week header and optionally the monthly header immediately after it
//   const renderWeekWithMaybeMonth = (globalWeekIndex, weekNumberForRender, keyBase) => {
//     const wrapped = weekInYear(weekNumberForRender);
//     const th = RenderWeekHeader(wrapped, weeklyRanges);
//     const elems = [];
//     // clone week header with stable key
//     elems.push(React.cloneElement(th, { key: `${keyBase}-wk-${globalWeekIndex}` }));

//     const monthIdx = lastWeekIndexToMonthIdx != null ? lastWeekIndexToMonthIdx[String(globalWeekIndex)] : undefined;
//     if (monthIdx !== undefined && monthIdx !== null) {
//       const label = monthLabelFromMeta(monthsMeta[monthIdx]);
//       elems.push(
//         <th key={`${keyBase}-mon-${monthIdx}`} className="monthly-agg-header">
//           {label || '-'}
//         </th>
//       );
//     }
//     return elems;
//   };

//   return (
//     <>
//       <th className='columfix text-left fixed-left'>KPI</th>

//       {PastActualsOneValue && <>
//         <th>Jan</th><th>Feb</th><th>Mar</th><th>Apr</th><th>May</th><th>Jun</th>
//         <th>July</th><th>Aug</th><th>Sep</th><th>Oct</th><th>Nov</th><th>Dec</th>
//       </>}

//       {PastActualsTwoValue && (
//         Array.from({ length: pastActualsCount }, (_, i) => {
//           // global week index (0-based) = i
//           return renderWeekWithMaybeMonth(i, i + 1, `pastA-${i}`);
//         })
//       )}

//       {PastForecastOneValue && (
//         Array.from({ length: forecastCount }, (_, i) => {
//           const globalWeekIndex = pastActualsCount + i;
//           const weekNumber = globalWeekIndex + 1;
//           return renderWeekWithMaybeMonth(globalWeekIndex, weekNumber, `pastF-${i}`);
//         })
//       )}

//       {PastForecastTwoValue && (
//         Array.from({ length: projectionCount }, (_, i) => {
//           const globalWeekIndex = pastActualsCount + forecastCount + i;
//           const weekNumber = globalWeekIndex + 1;
//           // Render week header and extra monthly header if this is last-week-of-month
//           const arr = renderWeekWithMaybeMonth(globalWeekIndex, weekNumber, `proj-${i}`);
//           // ensure projection headers keep data-projection-index on the week header (first element)
//           if (arr && arr.length && React.isValidElement(arr[0])) {
//             arr[0] = React.cloneElement(arr[0], { "data-projection-index": i, key: `proj-${i}-wk` });
//           }
//           return arr;
//         })
//       )}
//     </>
//   );
// }

import React, { useContext } from 'react'
import { AppContext } from '../../contexts/AppContext'
import RenderWeekHeader from './RenderWeekHeader';
import { MAX_WEEK_NUM } from "../../config";

const WEEKS_PER_YEAR = 59;
function weekInYear(weekAbs) {
  const n = Number(weekAbs);
  if (!Number.isFinite(n) || n <= 0) return 0;
  return ((Math.floor(n) - 1) % WEEKS_PER_YEAR) + 1;
}

function monthLabelFromMeta(mm) {
  if (!mm) return '';
  // mm could be [year, month] or { year, month }
  let y, m;
  if (Array.isArray(mm)) {
    y = mm[0]; m = mm[1];
  } else if (typeof mm === 'object') {
    y = mm.year ?? mm[0];
    m = mm.month ?? mm[1] ?? mm.month_number;
  } else {
    return String(mm);
  }
  if (!m) return String(mm);
  try {
    return new Date(Number(y) || new Date().getFullYear(), Number(m) - 1)
      .toLocaleString('en-US', { month: 'short', year: 'numeric' })
      .replace(/\s\d{4}$/, (y && ` ${y}`) || '');
  } catch {
    return `${m}/${y}`;
  }
}

export default function DynamicTableHeader({
  pastActualsCount,
  forecastCount,
  projectionCount,
  weeklyRanges,
  // legacy single-section props (kept for compatibility)
  lastWeekIndexToMonthIdx = {},
  monthsMeta = [],
  // new per-section props (preferred)
  lastWeekIndexToMonthIdxBySection = {},
  monthsMetaBySection = {}
}) {
  const { PastActualsOneValue, PastActualsTwoValue, PastForecastOneValue, PastForecastTwoValue } = useContext(AppContext);

  // Helper to resolve month index for a global week index using given section key.
  const getMonthIdxForGlobalWeek = (sectionKey, globalIdx) => {
    if (globalIdx == null) return undefined;
    if (globalIdx > MAX_WEEK_NUM) globalIdx = globalIdx - MAX_WEEK_NUM;

    // Prefer section-specific map if provided
    const canonical =
      sectionKey === 'pastActuals' || String(sectionKey).toLowerCase().includes('actual') ? 'pastActuals' :
        sectionKey === 'pastForecast' || String(sectionKey).toLowerCase().includes('forecast') ? 'pastForecast' :
          'projected';

    const sectionMap = lastWeekIndexToMonthIdxBySection && lastWeekIndexToMonthIdxBySection[canonical];
    if (sectionMap) {
      if (typeof sectionMap.get === 'function') return sectionMap.get(globalIdx);
      return sectionMap[String(globalIdx)];
    }

    // fallback to legacy single map
    if (!lastWeekIndexToMonthIdx) return undefined;
    if (typeof lastWeekIndexToMonthIdx.get === 'function') return lastWeekIndexToMonthIdx.get(globalIdx);
    return lastWeekIndexToMonthIdx[String(globalIdx)];
  };

  // Helper to get months meta for a section
  const getMonthsMetaForSection = (sectionKey) => {
    const canonical =
      sectionKey === 'pastActuals' || String(sectionKey).toLowerCase().includes('actual') ? 'pastActuals' :
        sectionKey === 'pastForecast' || String(sectionKey).toLowerCase().includes('forecast') ? 'pastForecast' :
          'projected';

    if (monthsMetaBySection && Array.isArray(monthsMetaBySection[canonical])) return monthsMetaBySection[canonical];
    return monthsMeta || [];
  };

  // helper to render a week header and optionally the monthly header immediately after it
  const renderWeekWithMaybeMonth = (globalWeekIndex, weekNumberForRender, keyBase, sectionKey = 'pastActuals') => {
    const wrapped = weekInYear(weekNumberForRender);
    const th = RenderWeekHeader(wrapped, weeklyRanges);
    const elems = [];
    // clone week header with stable key
    elems.push(React.cloneElement(th, { key: `${keyBase}-wk-${globalWeekIndex}` }));

    const monthIdx = getMonthIdxForGlobalWeek(sectionKey, globalWeekIndex);
    if (monthIdx !== undefined && monthIdx !== null) {
      const monthsForSection = getMonthsMetaForSection(sectionKey);
      const label = monthLabelFromMeta(monthsForSection[monthIdx]);
      elems.push(
        <th key={`${keyBase}-mon-${sectionKey}-${monthIdx}`} className="monthly-agg-header">
          {label || '-'}
        </th>
      );
    }
    return elems;
  };

  return (
    <>
      <th className='columfix text-left fixed-left'>KPI</th>

      {PastActualsOneValue && <>
        <th>Jan</th><th>Feb</th><th>Mar</th><th>Apr</th><th>May</th><th>Jun</th>
        <th>July</th><th>Aug</th><th>Sep</th><th>Oct</th><th>Nov</th><th>Dec</th>
      </>}

      {PastActualsTwoValue && (
        Array.from({ length: pastActualsCount }, (_, i) => {
          // global week index (0-based) = i
          return renderWeekWithMaybeMonth(i, i + 1, `pastA-${i}`, 'pastActuals');
        })
      )}

      {PastForecastOneValue && (
        Array.from({ length: forecastCount }, (_, i) => {
          const globalWeekIndex = pastActualsCount + i;
          const weekNumber = globalWeekIndex + 1;
          return renderWeekWithMaybeMonth(globalWeekIndex, weekNumber, `pastF-${i}`, 'pastForecast');
        })
      )}

      {PastForecastTwoValue && (
        Array.from({ length: projectionCount }, (_, i) => {
          const globalWeekIndex = pastActualsCount + forecastCount + i;
          const weekNumber = globalWeekIndex + 1;
          // Render week header and extra monthly header if this is last-week-of-month
          const arr = renderWeekWithMaybeMonth(globalWeekIndex, weekNumber, `proj-${i}`, 'projected');
          // ensure projection headers keep data-projection-index on the week header (first element)
          if (arr && arr.length && React.isValidElement(arr[0])) {
            arr[0] = React.cloneElement(arr[0], { "data-projection-index": i, key: `proj-${i}-wk` });
          }
          return arr;
        })
      )}
    </>
  );
}




